// 大屏
import axios from "../axios"
import {
    ICompanyAreaParams,
    IEquipmentAlarmStatisticsData,
    IEquipmentMapData,
    IScreenMachineStatisticsData,
    IScreenMappingAlarmStatisticsRecordData,
    IScreenPointAlarmHistoryData
} from "./screen.types"

/**
 * 首页大屏 左侧设备统计
 */
export function screenMachineStatistics(params?: ICompanyAreaParams) {
    return axios<IScreenMachineStatisticsData>({
        method: 'get',
        url: '/screen/getMachineStatistics',
        params,
    })
}

/**
 *  查询测点报警记录
 */
export function screenPointAlarmHistory(params?: ICompanyAreaParams) {
    return axios<IScreenPointAlarmHistoryData>({
        method: 'get',
        url: '/screen/get/point/alarm/history',
        params,
    })
}

/**
 * 大屏月设备统计
 */
export function screenEquipmentAlarmStatistics(params?: ICompanyAreaParams) {
    return axios<IEquipmentAlarmStatisticsData>({
        method: 'get',
        url: '/screen/getEquipmentAlarmStatistics',
        params,
    })
}

/**
 * 大屏地图数据
 */
export function screenEquipmentMap() {
    return axios<IEquipmentMapData>({
        method: 'get',
        url: '/screen/getEquipmentMap',
    })
}

/**
 * 月测点报警记录统计 
 */
export function screenMappingAlarmStatisticsRecord(params?: ICompanyAreaParams) {
    return axios<IScreenMappingAlarmStatisticsRecordData>({
        method: 'get',
        url: '/screen/getMappingAlarmStatisticsRecord',
        params,
    })
}
